import { Trans, useTranslation } from "@coworker/locales";
import styles from "./privacy-statement.module.css";

const INDIVIDUAL_RIGHTS_URL =
  "https://iweof.sharepoint.com/sites/sup/dp/SitePages/Individual-rights.aspx";
const FIXA_EMAIL = "fixa.support@ikea.com";

function Section({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <section>
      <p className={styles["sectionTitle"]}>{title}</p>
      <div>{children}</div>
    </section>
  );
}

export default function PrivacyStatement() {
  const { t } = useTranslation();

  return (
    <div className={styles["content"]} data-testid="privacyContent">
      <h1>{t("privacyStatementTitleString")}</h1>

      <p>{t("privacyStatementIntroString")}</p>

      <p>
        <Trans
          i18nKey="privacyStatementDataCollectionIntroString"
          values={{ email: FIXA_EMAIL }}
          components={{
            1: <a className={styles["link"]} href={`mailto:${FIXA_EMAIL}`} />,
          }}
        />
      </p>

      <Section title={t("privacyStatementPersonalDataCollectedTitleString")}>
        <p>{t("privacyStatementPersonalDataCollectedText1String")}</p>
        <p>{t("privacyStatementPersonalDataCollectedText2String")}</p>
      </Section>

      <Section title={t("privacyStatementPurposeTitleString")}>
        <p>{t("privacyStatementPurposeTextString")}</p>
      </Section>

      <Section title={t("privacyStatementLegalGroundTitleString")}>
        <p>{t("privacyStatementLegalGroundTextString")}</p>
      </Section>

      <Section title={t("privacyStatementDataStoredTitleString")}>
        <p>{t("privacyStatementDataStoredText1String")}</p>
        <p>{t("privacyStatementDataStoredText2String")}</p>
        <p>{t("privacyStatementDataStoredText3String")}</p>
        <p>{t("privacyStatementDataStoredText4String")}</p>
      </Section>

      <Section title={t("privacyStatementDataControllerTitleString")}>
        {t("privacyStatementDataControllerTextString")}
      </Section>
      <p>
        {t("privacyStatementFixaTeamString")}{" "}
        <a className={styles["link"]} href={`mailto:${FIXA_EMAIL}`}>
          {FIXA_EMAIL}
        </a>
      </p>
      <p>
        <Trans
          i18nKey="privacyStatementRightsTextString"
          components={{
            1: (
              <a
                className={styles["link"]}
                href={INDIVIDUAL_RIGHTS_URL}
                target="_blank"
                rel="noopener noreferrer"
              />
            ),
          }}
        />
      </p>
    </div>
  );
}
